import PageControlsContainer from './PageControlsContainer';

export default PageControlsContainer;